import React from "react";
import { GiftIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { BookCover } from "./BookCover";
import { bonuses } from "../data/landing";
export function BonusSection() {
  return <section className="bg-gold-light" data-id="element-1" data-mp="22ebuv3p4zae6">
      <div className="mx-auto max-w-4xl px-5 py-16 md:py-24" data-id="element-2" data-mp="22dagoqctq7s8">
        <SectionHeading eyebrow="And That's Not All…" title={<>
              You'll Also Get <span className="text-royal" data-id="element-4" data-mp="1aop5xzg7sxjt">5 Exclusive Bonus Guides</span> — FREE!
            </>} subtitle={<>
              <p data-id="element-5" data-mp="1jhaopfjuj48n">The six main volumes help your child explore the reasons behind Christian faith.</p>
              <p data-id="element-6" data-mp="1epitgrpqwac6">
                These five special resources help <strong className="font-bold text-ink" data-id="element-7" data-mp="1enxzb37ceteu">YOU</strong> navigate the
                conversations, doubts, and questions that come along the way.
              </p>
            </>} data-id="element-3" data-mp="1yfcpjhzhtbm7" />

        <ul className="mt-12 space-y-5" data-id="element-8" data-mp="mx1yj0yk4f7x">
          {bonuses.map(b => <li key={b.number} className="grid items-center gap-6 rounded-3xl bg-white p-6 shadow-[0_12px_32px_-20px_rgba(143,92,5,0.45)] sm:grid-cols-[160px_1fr] md:p-8" data-id="element-9" data-mp="29rjt4m8vs98r">
              <div className="mx-auto w-36 sm:w-full" data-id="element-10" data-mp="2jjzc9mvwz3v8">
                <BookCover variant="bonus" kicker={`Bonus #${b.number}`} title={b.coverTitle} color={b.color} icon={b.icon} data-id="element-11" data-mp="2oh9233n7thjl" />
              </div>
              <div data-id="element-12" data-mp="1vu51rbz2hre5">
                <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-gold-deep" data-id="element-13" data-mp="20roeu8k13y4i">
                  Bonus #{b.number}
                </p>
                <h3 className="mt-1 font-display text-2xl font-extrabold leading-tight text-ink" data-id="element-14" data-mp="25oesyqc9wjna">{b.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-15" data-mp="3c8whopf1166k">{b.text}</p>
                <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-leaf-light px-3.5 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-leaf" data-id="element-16" data-mp="3h3tpxu4hfbie">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-17" data-mp="1c3iwvlk4f9nz" />
                  Included Free
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-18" data-mp="1m3jjbgdae5we">
          <p className="font-display text-xl font-extrabold text-navy md:text-2xl" data-id="element-19" data-mp="1m0dr3s9d2nwg">
            All 5 Bonus Guides Are Included at No Extra Cost!
          </p>
          <p className="mt-1 font-semibold text-ink-soft" data-id="element-20" data-mp="tevs745uwmax">One Complete Bundle. One Payment of Just $27.</p>
        </div>
      </div>
    </section>;
}